import React from "react";
import {
  Breadcrumb,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from "@commonsku/design-system";

export interface AutomationBreadcrumbsProps {
  workflowName: string;
}

/**
 * Breadcrumb trail for the automation editor: "Automations > {workflow name}".
 */
const AutomationBreadcrumbs = ({
  workflowName,
}: AutomationBreadcrumbsProps) => {
  return (
    <Breadcrumb>
      <BreadcrumbLink href="/automations" isCurrent={false}>
        Automations
      </BreadcrumbLink>
      <BreadcrumbSeparator />
      <BreadcrumbLink isCurrent>{workflowName}</BreadcrumbLink>
    </Breadcrumb>
  );
};

export default AutomationBreadcrumbs;
